(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_ke-size-guide"] && !Shopify.designMode) return;
  try {
    const KE_PDP_SIZES = [
    { id: '8x10', pw: 8, ph: 10, cmW: 20, cmH: 25, canvasOnly: false },
    { id: '11x14', pw: 11, ph: 14, cmW: 28, cmH: 35, canvasOnly: false },
    { id: '12x16', pw: 12, ph: 16, cmW: 30, cmH: 40, canvasOnly: true },
    { id: '16x20', pw: 16, ph: 20, cmW: 40, cmH: 50, canvasOnly: false },
    { id: '18x24', pw: 18, ph: 24, cmW: 45, cmH: 60, canvasOnly: false },
    { id: '20x30', pw: 20, ph: 30, cmW: 50, cmH: 75, canvasOnly: false },
    { id: '24x30', pw: 24, ph: 30, cmW: 60, cmH: 75, canvasOnly: true },
    { id: '24x36', pw: 24, ph: 36, cmW: 60, cmH: 90, canvasOnly: false },
    { id: '30x40', pw: 30, ph: 40, cmW: 75, cmH: 100, canvasOnly: false }
  ];

  const KE_PDP_ROOMS = {
    living: {
      label: 'Sofa width',
      short: 'sofa',
      type: 'sofa',
      w: 84,
      fh: 33,
      presets: [
        { label: '62 in Loveseat', labelCm: '157 cm Loveseat', w: 62, fh: 32, type: 'sofa' },
        { label: '74 in Apt Sofa', labelCm: '188 cm Apt Sofa', w: 74, fh: 33, type: 'sofa' },
        { label: '84 in Standard Sofa', labelCm: '213 cm Standard Sofa', w: 84, fh: 33, type: 'sofa' },
        { label: '96 in Sectional', labelCm: '244 cm Sectional', w: 96, fh: 34, type: 'sofa' }
      ],
      buyerIn: '<strong>Living Room buyer data:</strong> 54% choose 36 × 24 in or 40 × 30 in as a single focal print; 34% pair two 18 × 24 in or 20 × 30 in prints.',
      buyerCm: '<strong>Living Room buyer data:</strong> 54% choose 90 × 60 cm or 100 × 75 cm as a single focal print; 34% pair two 45 × 60 cm or 50 × 75 cm prints.'
    },
    bedroom: {
      label: 'Bed headboard width',
      short: 'headboard',
      type: 'bed',
      w: 60,
      fh: 44,
      presets: [
        { label: '54 in Full Bed', labelCm: '137 cm Full Bed', w: 54, fh: 42, type: 'bed' },
        { label: '60 in Queen Bed', labelCm: '152 cm Queen Bed', w: 60, fh: 44, type: 'bed' },
        { label: '76 in King Bed', labelCm: '193 cm King Bed', w: 76, fh: 46, type: 'bed' }
      ],
      buyerIn: '<strong>Bedroom buyer data:</strong> 49% hang two 18 × 24 in or 20 × 30 in prints side by side; 38% choose a single 36 × 24 in or 24 × 36 in centerpiece.',
      buyerCm: '<strong>Bedroom buyer data:</strong> 49% hang two 45 × 60 cm or 50 × 75 cm prints side by side; 38% choose a single 90 × 60 cm or 60 × 90 cm centerpiece.'
    },
    office: {
      label: 'Desk or credenza width',
      short: 'desk',
      type: 'desk',
      w: 54,
      fh: 30,
      presets: [
        { label: '48 in Writing Desk', labelCm: '122 cm Writing Desk', w: 48, fh: 30, type: 'desk' },
        { label: '60 in Standing Desk', labelCm: '152 cm Standing Desk', w: 60, fh: 30, type: 'desk' },
        { label: '72 in Credenza', labelCm: '183 cm Credenza', w: 72, fh: 31, type: 'console' }
      ],
      buyerIn: '<strong>Home Office buyer data:</strong> 62% choose a single 18 × 24 in or 24 × 18 in focal print centered 7 in above the desk.',
      buyerCm: '<strong>Home Office buyer data:</strong> 62% choose a single 45 × 60 cm or 60 × 45 cm focal print centered 18 cm above the desk.'
    },
    dining: {
      label: 'Sideboard or table width',
      short: 'sideboard',
      type: 'console',
      w: 66,
      fh: 34,
      presets: [
        { label: '60 in Sideboard', labelCm: '152 cm Sideboard', w: 60, fh: 34, type: 'console' },
        { label: '72 in Dining Table', labelCm: '183 cm Dining Table', w: 72, fh: 30, type: 'dining' },
        { label: '84 in Dining Table', labelCm: '213 cm Dining Table', w: 84, fh: 30, type: 'dining' }
      ],
      buyerIn: '<strong>Dining Room buyer data:</strong> 57% choose a single 36 × 24 in or 30 × 24 in print (71% in Solid Oak Framed Canvas).',
      buyerCm: '<strong>Dining Room buyer data:</strong> 57% choose a single 90 × 60 cm or 75 × 60 cm print (71% in Solid Oak Framed Canvas).'
    },
    entryway: {
      label: 'Console or wall width',
      short: 'console',
      type: 'console',
      w: 44,
      fh: 32,
      presets: [
        { label: '36 in Entry Bench', labelCm: '91 cm Entry Bench', w: 36, fh: 20, type: 'console' },
        { label: '48 in Console Table', labelCm: '122 cm Console Table', w: 48, fh: 32, type: 'console' },
        { label: 'Open Wall (Eye Level)', labelCm: 'Open Wall (Eye Level)', w: 60, fh: 0, type: 'open' }
      ],
      buyerIn: '<strong>Entryway buyer data:</strong> 58% choose a single 24 × 36 in statement print; 28% choose 18 × 24 in above narrow consoles.',
      buyerCm: '<strong>Entryway buyer data:</strong> 58% choose a single 60 × 90 cm statement print; 28% choose 45 × 60 cm above narrow consoles.'
    }
  };

  class KeSizeGuide extends HTMLElement {
    connectedCallback() {
      this.productDetails = this.closest('.product-details');
      this.section = this.closest('.shopify-section');
      this.handleChange = this.handleChange.bind(this);
      this.handleUnitChange = this.handleUnitChange.bind(this);
      this.handleModalClick = this.handleModalClick.bind(this);
      this.handleSliderInput = this.handleSliderInput.bind(this);
      this.onTriggerClick = this.onTriggerClick.bind(this);

      this.productDetails?.addEventListener('change', this.handleChange);
      this.section?.addEventListener('ke:unit-change', this.handleUnitChange);

      this.triggerBtn = this.querySelector('.ke-size-guide__trigger');
      this.triggerBtn?.addEventListener('click', this.onTriggerClick);

      try {
        const savedUnit = window.localStorage.getItem('ke_size_unit');
        if (savedUnit === 'cm') {
          this.updateDisplayedUnit('cm');
        }
      } catch (e) {}
    }

    disconnectedCallback() {
      this.productDetails?.removeEventListener('change', this.handleChange);
      this.section?.removeEventListener('ke:unit-change', this.handleUnitChange);
      this.triggerBtn?.removeEventListener('click', this.onTriggerClick);
    }

    onTriggerClick() {
      if (!this._calcReady) {
        this.initModalCalculator();
      }
      this.syncCalcFromPdpState();
      this.renderModalCalculator();
    }

    initModalCalculator() {
      this._calcReady = true;
      const defaultRoom = this.dataset.defaultRoom || 'living';
      const roomObj = KE_PDP_ROOMS[defaultRoom] || KE_PDP_ROOMS.living;
      this.calcState = {
        room: defaultRoom,
        type: roomObj.type,
        w: roomObj.w,
        fh: roomObj.fh,
        orient: this.dataset.orient === 'landscape' ? 'landscape' : 'portrait',
        sizeId: '18x24',
        unit: this.getCurrentUnit()
      };

      const artImg = this.querySelector('[data-pdp-svg="art-img"]');
      const artUrl = this.dataset.artworkUrl;
      if (artImg && artUrl && !artImg.getAttribute('href')) {
        artImg.setAttribute('href', artUrl);
      }

      const dialog = this.querySelector('dialog');
      dialog?.addEventListener('click', this.handleModalClick);
      const range = this.querySelector('[data-pdp-input="w"]');
      range?.addEventListener('input', this.handleSliderInput);
    }

    parseSizeIdFromString(str) {
      if (!str) return null;
      const s = str.toLowerCase();
      if (s.includes('30') && s.includes('40')) return '30x40';
      if (s.includes('24') && s.includes('36')) return '24x36';
      if (s.includes('24') && s.includes('30')) return '24x30';
      if (s.includes('20') && s.includes('30')) return '20x30';
      if (s.includes('18') && s.includes('24')) return '18x24';
      if (s.includes('16') && s.includes('20')) return '16x20';
      if (s.includes('12') && s.includes('16')) return '12x16';
      if (s.includes('11') && s.includes('14')) return '11x14';
      if (s.includes('8') && s.includes('10')) return '8x10';
      return null;
    }

    syncCalcFromPdpState() {
      if (!this.calcState) return;
      this.calcState.unit = this.getCurrentUnit();
      const sizeInput = this.productDetails?.querySelector('input[data-option-name="Size"]:checked:not([data-ke-digital-input="true"])');
      const rawVal = sizeInput instanceof HTMLInputElement
        ? sizeInput.value
        : this.querySelector('.ke-size-guide__selected-size')?.getAttribute('data-label-in') || '';
      const parsed = this.parseSizeIdFromString(rawVal);
      if (parsed) {
        this.calcState.sizeId = parsed;
      }
    }

    handleSliderInput(event) {
      if (!this.calcState) return;
      const val = Number(event.target.value) || 84;
      this.calcState.w = Math.max(36, Math.min(110, val));
      this.renderModalCalculator();
    }

    handleModalClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target || !this.calcState) return;

      const unitBtn = target.closest('[data-pdp-unit]');
      if (unitBtn instanceof HTMLElement) {
        const u = unitBtn.dataset.pdpUnit === 'cm' ? 'cm' : 'in';
        this.calcState.unit = u;
        const selector = this.section?.querySelector('ke-format-selector');
        if (selector && typeof selector.applyUnit === 'function') {
          selector.applyUnit(u, true);
        } else {
          this.updateDisplayedUnit(u);
        }
        this.renderModalCalculator();
        return;
      }

      const roomBtn = target.closest('[data-pdp-room]');
      if (roomBtn instanceof HTMLElement) {
        const rKey = roomBtn.dataset.pdpRoom || 'living';
        const rObj = KE_PDP_ROOMS[rKey];
        if (rObj) {
          this.calcState.room = rKey;
          this.calcState.type = rObj.type;
          this.calcState.w = rObj.w;
          this.calcState.fh = rObj.fh;
          const range = this.querySelector('[data-pdp-input="w"]');
          if (range) range.value = String(rObj.w);
          this.renderModalCalculator();
        }
        return;
      }

      const presetBtn = target.closest('[data-pdp-preset-idx]');
      if (presetBtn instanceof HTMLElement) {
        const idx = Number(presetBtn.dataset.pdpPresetIdx);
        const rObj = KE_PDP_ROOMS[this.calcState.room];
        const p = rObj?.presets?.[idx];
        if (p) {
          this.calcState.w = p.w;
          this.calcState.fh = p.fh;
          this.calcState.type = p.type;
          const range = this.querySelector('[data-pdp-input="w"]');
          if (range) range.value = String(p.w);
          this.renderModalCalculator();
        }
        return;
      }

      const sizeBtn = target.closest('[data-pdp-size]');
      if (sizeBtn instanceof HTMLElement) {
        this.calcState.sizeId = sizeBtn.dataset.pdpSize || '18x24';
        this.renderModalCalculator();
        return;
      }

      const applyBtn = target.closest('[data-pdp-action="apply-size"]');
      if (applyBtn instanceof HTMLElement) {
        this.applySelectedSizeToPdp();
      }
    }

    applySelectedSizeToPdp() {
      if (!this.calcState) return;
      const sizeObj = KE_PDP_SIZES.find((s) => s.id === this.calcState.sizeId) || KE_PDP_SIZES[4];
      const selector = this.section?.querySelector('ke-format-selector');
      if (selector) {
        const optButtons = Array.from(selector.querySelectorAll('[data-ke-size-option]'));
        const matchBtn = optButtons.find((btn) => {
          const raw = btn.getAttribute('data-ke-label-in') || btn.getAttribute('data-ke-size-option') || '';
          return this.parseSizeIdFromString(raw) === sizeObj.id;
        });
        if (matchBtn && typeof selector.selectPhysicalSize === 'function') {
          const rawVal = matchBtn.getAttribute('data-ke-size-option') || '';
          if (selector.dataset.keMaterial === 'digital' && typeof selector.selectMaterial === 'function') {
            selector.selectMaterial(sizeObj.canvasOnly ? 'canvas' : 'poster');
          }
          selector.selectPhysicalSize(rawVal);
        }
      }

      const dialogComp = this.querySelector('dialog-component');
      if (dialogComp && typeof dialogComp.closeDialog === 'function') {
        dialogComp.closeDialog();
      } else {
        const dialog = this.querySelector('dialog');
        dialog?.close();
      }
    }

    formatDimLabel(sizeObj, orient, unit) {
      const wIn = orient === 'landscape' ? sizeObj.ph : sizeObj.pw;
      const hIn = orient === 'landscape' ? sizeObj.pw : sizeObj.ph;
      const wCm = orient === 'landscape' ? sizeObj.cmH : sizeObj.cmW;
      const hCm = orient === 'landscape' ? sizeObj.cmW : sizeObj.cmH;
      return unit === 'cm' ? `${wCm} × ${hCm} cm` : `${wIn} × ${hIn} in`;
    }

    fmtLen(inches, unit) {
      const v = Math.round(inches);
      if (unit === 'cm') return `${Math.round(inches * 2.54)} cm`;
      return `${v} in`;
    }

    renderModalCalculator() {
      if (!this.calcState) return;
      const st = this.calcState;
      const rObj = KE_PDP_ROOMS[st.room] || KE_PDP_ROOMS.living;
      const curSize = KE_PDP_SIZES.find((s) => s.id === st.sizeId) || KE_PDP_SIZES[4];
      const printW = st.orient === 'landscape' ? curSize.ph : curSize.pw;
      const printH = st.orient === 'landscape' ? curSize.pw : curSize.ph;

      for (const b of this.querySelectorAll('[data-pdp-unit]')) {
        b.classList.toggle('is-active', b.getAttribute('data-pdp-unit') === st.unit);
      }

      for (const b of this.querySelectorAll('[data-pdp-room]')) {
        b.classList.toggle('is-active', b.getAttribute('data-pdp-room') === st.room);
      }

      const presetsEl = this.querySelector('[data-pdp-presets]');
      if (presetsEl) {
        presetsEl.innerHTML = rObj.presets
          .map((p, i) => {
            const active = p.w === st.w && p.type === st.type;
            const lbl = st.unit === 'cm' ? p.labelCm : p.label;
            return `<button type="button" class="ke-pdp-calc__preset-chip${active ? ' is-active' : ''}" data-pdp-preset-idx="${i}">${lbl}</button>`;
          })
          .join('');
      }

      const wGroup = this.querySelector('[data-pdp-width-group]');
      if (wGroup) {
        wGroup.style.display = st.type === 'open' ? 'none' : '';
      }
      const wLabel = this.querySelector('[data-pdp-out="w-label"]');
      if (wLabel) wLabel.textContent = `02 · ${rObj.label}`;
      const wVal = this.querySelector('[data-pdp-out="w-val"]');
      if (wVal) {
        wVal.textContent = st.unit === 'cm'
          ? `${Math.round(st.w * 2.54)} cm (${st.w} in)`
          : `${st.w} in (${Math.round(st.w * 2.54)} cm)`;
      }

      const sizesEl = this.querySelector('[data-pdp-sizes]');
      if (sizesEl) {
        sizesEl.innerHTML = KE_PDP_SIZES.map((s) => {
          const sw = st.orient === 'landscape' ? s.ph : s.pw;
          const ratio = st.type === 'open' ? 0.6 : sw / st.w;
          const fits = st.type === 'open' ? sw >= 18 : ratio >= 0.38 && ratio <= 0.78;
          const active = s.id === st.sizeId;
          const dimText = this.formatDimLabel(s, st.orient, st.unit);
          const subText = this.formatDimLabel(s, st.orient, st.unit === 'in' ? 'cm' : 'in');
          return `<button type="button" class="ke-pdp-calc__size-btn${active ? ' is-active' : ''}" data-pdp-size="${s.id}">
            <span class="ke-pdp-calc__size-main">${dimText}</span>
            <span class="ke-pdp-calc__size-sub">
              <span>${subText}</span>
              ${fits ? '<span class="ke-pdp-calc__fit-pill">FITS</span>' : ''}
            </span>
          </button>`;
        }).join('');
      }

      const ratioPct = Math.round((printW / st.w) * 100);
      const ratioEl = this.querySelector('[data-pdp-out="ratio"]');
      const badgeEl = this.querySelector('[data-pdp-out="badge"]');
      if (st.type === 'open') {
        if (ratioEl) ratioEl.textContent = `${this.formatDimLabel(curSize, st.orient, st.unit)} standalone`;
        if (badgeEl) {
          badgeEl.className = 'ke-pdp-calc__badge is-good';
          badgeEl.textContent = printW >= 18 ? 'Gallery scale' : 'Accent scale';
        }
      } else {
        if (ratioEl) ratioEl.textContent = `${ratioPct}% of ${rObj.short} width`;
        if (badgeEl) {
          if (ratioPct >= 50 && ratioPct <= 78) {
            badgeEl.className = 'ke-pdp-calc__badge is-good';
            badgeEl.textContent = 'Ideal 2/3 proportion';
          } else if (ratioPct >= 34 && ratioPct < 50) {
            badgeEl.className = 'ke-pdp-calc__badge is-good';
            badgeEl.textContent = 'Balanced focal size';
          } else if (ratioPct < 34) {
            badgeEl.className = 'ke-pdp-calc__badge is-warn';
            badgeEl.textContent = 'Compact — pair 2 side by side';
          } else {
            badgeEl.className = 'ke-pdp-calc__badge is-warn';
            badgeEl.textContent = 'Wide — check wall edges';
          }
        }
      }

      const heightEl = this.querySelector('[data-pdp-out="height"]');
      const centerEl = this.querySelector('[data-pdp-out="center"]');
      const gapAbove = 7;
      if (st.type === 'open') {
        const centerIn = 58;
        const bottomIn = Math.round(centerIn - printH / 2);
        if (heightEl) heightEl.textContent = `Center at ${this.fmtLen(centerIn, st.unit)} eye level`;
        if (centerEl) centerEl.textContent = `Bottom edge ${this.fmtLen(bottomIn, st.unit)} from floor`;
      } else {
        const bottomIn = st.fh + gapAbove;
        const centerIn = Math.round(bottomIn + printH / 2);
        if (heightEl) heightEl.textContent = `Bottom edge ${this.fmtLen(gapAbove, st.unit)} above ${rObj.short}`;
        if (centerEl) centerEl.textContent = `Center at ${this.fmtLen(centerIn, st.unit)} from floor`;
      }

      const buyerEl = this.querySelector('[data-pdp-out="buyer-note"]');
      if (buyerEl) {
        buyerEl.innerHTML = st.unit === 'cm' ? rObj.buyerCm : rObj.buyerIn;
      }

      const applyLabel = this.querySelector('[data-pdp-out="apply-label"]');
      if (applyLabel) {
        applyLabel.textContent = this.formatDimLabel(curSize, st.orient, st.unit);
      }

      const fullLink = this.querySelector('[data-pdp-out="full-link"]');
      if (fullLink) {
        fullLink.setAttribute(
          'href',
          `/pages/size-guide?orient=${encodeURIComponent(st.orient)}&size=${encodeURIComponent(st.sizeId)}&room=${encodeURIComponent(st.room)}&u=${encodeURIComponent(st.unit)}`
        );
      }

      this.drawWallSvg(st, rObj, printW, printH);
    }

    drawWallSvg(st, rObj, printW, printH) {
      const floorY = 330;
      const centerX = 320;
      const pxPerIn = 2.85;

      const selector = this.section?.querySelector('ke-format-selector');
      const frameMode = selector?.dataset?.keFrame || 'black';
      const strokeHex = frameMode === 'oak' ? '#b5895a' : frameMode === 'none' || frameMode === 'canvas' ? '#3d3935' : '#1c1b19';
      const framePad = frameMode === 'none' || frameMode === 'canvas' ? 1.5 : 4;

      const artWpx = Math.round(printW * pxPerIn);
      const artHpx = Math.round(printH * pxPerIn);
      const furnWpx = Math.round(st.w * pxPerIn);
      const furnHpx = Math.round(st.fh * pxPerIn);
      const furnTopY = floorY - furnHpx;

      let artBottomY = furnTopY - Math.round(7 * pxPerIn);
      if (st.type === 'open') {
        const eyeY = floorY - Math.round(58 * pxPerIn);
        artBottomY = Math.round(eyeY + artHpx / 2);
      }
      const artTopY = Math.max(18, artBottomY - artHpx);
      const artLeftX = Math.round(centerX - artWpx / 2);

      const outerRect = this.querySelector('[data-pdp-svg="frame-outer"]');
      const matRect = this.querySelector('[data-pdp-svg="frame-mat"]');
      const clipRect = this.querySelector('[data-pdp-svg="clip-rect"]');
      const artImg = this.querySelector('[data-pdp-svg="art-img"]');

      if (outerRect) {
        outerRect.setAttribute('x', String(artLeftX - framePad));
        outerRect.setAttribute('y', String(artTopY - framePad));
        outerRect.setAttribute('width', String(artWpx + framePad * 2));
        outerRect.setAttribute('height', String(artHpx + framePad * 2));
        outerRect.setAttribute('fill', strokeHex);
      }
      for (const el of [matRect, clipRect, artImg]) {
        if (!el) continue;
        el.setAttribute('x', String(artLeftX));
        el.setAttribute('y', String(artTopY));
        el.setAttribute('width', String(artWpx));
        el.setAttribute('height', String(artHpx));
      }

      const targetBand = this.querySelector('[data-pdp-svg="target-band"]');
      if (targetBand) {
        if (st.type === 'open') {
          targetBand.innerHTML = '';
        } else {
          const idealWpx = Math.round(st.w * 0.67 * pxPerIn);
          const idealX = Math.round(centerX - idealWpx / 2);
          targetBand.innerHTML = `<rect x="${idealX}" y="${artTopY - 8}" width="${idealWpx}" height="${artHpx + 16}" fill="none" stroke="#1f6b45" stroke-opacity="0.28" stroke-dasharray="3 3" rx="2" />`;
        }
      }

      const furnGroup = this.querySelector('[data-pdp-svg="furniture"]');
      if (furnGroup) {
        const fx = Math.round(centerX - furnWpx / 2);
        if (st.type === 'open') {
          furnGroup.innerHTML = '';
        } else if (st.type === 'bed') {
          const mattH = Math.round(furnHpx * 0.48);
          furnGroup.innerHTML = `
            <rect x="${fx}" y="${furnTopY}" width="${furnWpx}" height="${furnHpx - 6}" rx="4" fill="#d9d0c3" stroke="#9e9384" stroke-width="1.5"/>
            <rect x="${fx + 14}" y="${floorY - mattH - 14}" width="${Math.max(24, furnWpx / 2 - 20)}" height="14" rx="5" fill="#f7f4ee" stroke="#9e9384" stroke-width="1.2"/>
            <rect x="${centerX + 6}" y="${floorY - mattH - 14}" width="${Math.max(24, furnWpx / 2 - 20)}" height="14" rx="5" fill="#f7f4ee" stroke="#9e9384" stroke-width="1.2"/>
            <rect x="${fx - 2}" y="${floorY - mattH - 4}" width="${furnWpx + 4}" height="${mattH}" rx="3" fill="#eae3d8" stroke="#9e9384" stroke-width="1.5"/>
          `;
        } else if (st.type === 'desk' || st.type === 'dining') {
          furnGroup.innerHTML = `
            <rect x="${fx}" y="${furnTopY}" width="${furnWpx}" height="8" rx="1" fill="#c7b8a3" stroke="#8c7d6a" stroke-width="1.5"/>
            <line x1="${fx + 14}" y1="${furnTopY + 8}" x2="${fx + 10}" y2="${floorY}" stroke="#8c7d6a" stroke-width="3"/>
            <line x1="${fx + furnWpx - 14}" y1="${furnTopY + 8}" x2="${fx + furnWpx - 10}" y2="${floorY}" stroke="#8c7d6a" stroke-width="3"/>
          `;
        } else if (st.type === 'console') {
          furnGroup.innerHTML = `
            <rect x="${fx}" y="${furnTopY}" width="${furnWpx}" height="${furnHpx - 14}" rx="2" fill="#d3c7b6" stroke="#8c7d6a" stroke-width="1.5"/>
            <line x1="${centerX}" y1="${furnTopY}" x2="${centerX}" y2="${floorY - 14}" stroke="#8c7d6a" stroke-width="1.2"/>
            <line x1="${fx + 12}" y1="${floorY - 14}" x2="${fx + 12}" y2="${floorY}" stroke="#8c7d6a" stroke-width="2.5"/>
            <line x1="${fx + furnWpx - 12}" y1="${floorY - 14}" x2="${fx + furnWpx - 12}" y2="${floorY}" stroke="#8c7d6a" stroke-width="2.5"/>
          `;
        } else {
          const seatH = Math.round(furnHpx * 0.46);
          const armW = 14;
          furnGroup.innerHTML = `
            <rect x="${fx + armW - 2}" y="${furnTopY}" width="${furnWpx - armW * 2 + 4}" height="${furnHpx - 8}" rx="5" fill="#dcd4c8" stroke="#9c9183" stroke-width="1.5"/>
            <rect x="${fx}" y="${furnTopY + 12}" width="${armW}" height="${furnHpx - 18}" rx="4" fill="#d1c8ba" stroke="#9c9183" stroke-width="1.5"/>
            <rect x="${fx + furnWpx - armW}" y="${furnTopY + 12}" width="${armW}" height="${furnHpx - 18}" rx="4" fill="#d1c8ba" stroke="#9c9183" stroke-width="1.5"/>
            <rect x="${fx + armW}" y="${floorY - seatH - 6}" width="${furnWpx - armW * 2}" height="${seatH}" rx="3" fill="#e6dfd4" stroke="#9c9183" stroke-width="1.5"/>
            <line x1="${centerX}" y1="${furnTopY + 4}" x2="${centerX}" y2="${floorY - 6}" stroke="#9c9183" stroke-width="1.2"/>
          `;
        }
      }

      const dimsGroup = this.querySelector('[data-pdp-svg="dims"]');
      if (dimsGroup) {
        const wText = `${this.fmtLen(printW, st.unit)} × ${this.fmtLen(printH, st.unit)}`;
        const furnText = st.type === 'open' ? '58 in (147 cm) gallery eye level' : `${this.fmtLen(st.w, st.unit)} ${rObj.short}`;
        dimsGroup.innerHTML = `
          <text x="${centerX}" y="${Math.max(13, artTopY - 8)}" text-anchor="middle" font-size="11" font-weight="600" fill="#17131a">${wText}</text>
          <text x="${centerX}" y="352" text-anchor="middle" font-size="11" font-weight="600" fill="#4f4942">${furnText}</text>
        `;
      }
    }

    getCurrentUnit() {
      const selector = this.section?.querySelector('ke-format-selector');
      if (selector?.dataset?.keUnit === 'cm') return 'cm';
      if (this.section?.dataset?.keUnit === 'cm') return 'cm';
      return 'in';
    }

    handleUnitChange(event) {
      const unit = event.detail?.unit === 'cm' ? 'cm' : 'in';
      this.updateDisplayedUnit(unit);
      if (this.calcState) {
        this.calcState.unit = unit;
        this.renderModalCalculator();
      }
    }

    updateDisplayedUnit(unit) {
      if (this.dataset.digital === 'true') return;
      const sizeElement = this.querySelector('.ke-size-guide__selected-size');
      if (!sizeElement) return;
      const text = unit === 'cm'
        ? sizeElement.getAttribute('data-label-cm')
        : sizeElement.getAttribute('data-label-in');
      if (text) sizeElement.textContent = text;
    }

    handleChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

      const sizeInput = this.productDetails?.querySelector('input[data-option-name="Size"]:checked');
      const rawValue = sizeInput instanceof HTMLInputElement
        ? sizeInput.value
        : target instanceof HTMLSelectElement
          ? target.options[target.selectedIndex]?.value
          : target.value;
      const size = rawValue
        ?.replace(/\s*\((vertical|horizontal)\)/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!size) return;

      const scaleLine = this.querySelector('.ke-size-guide__scale-line');
      const sizeElement = this.querySelector('.ke-size-guide__selected-size');
      const hintElement = this.querySelector('.ke-size-guide__selected-hint');
      const separator = this.querySelector('.ke-size-guide__sep');
      const digital = size.toLowerCase() === 'digital download' || size.toLowerCase() === 'digital print';

      if (digital) {
        this.dataset.digital = 'true';
        if (scaleLine) scaleLine.hidden = true;
        if (sizeElement) sizeElement.textContent = 'Digital Print';
        if (hintElement) hintElement.hidden = true;
        if (separator) separator.hidden = true;
        return;
      }

      if (!/8|10|11|12|14|16|18|20|24|30|36|40/.test(size)) return;

      let hint = this.getAttribute('data-hint-8x10');
      if (size.includes('30') && size.includes('40')) hint = this.getAttribute('data-hint-30x40');
      else if (size.includes('24') && size.includes('36')) hint = this.getAttribute('data-hint-24x36');
      else if (size.includes('24') && size.includes('30')) hint = this.getAttribute('data-hint-24x30');
      else if (size.includes('20') && size.includes('30')) hint = this.getAttribute('data-hint-20x30');
      else if (size.includes('18') && size.includes('24')) hint = this.getAttribute('data-hint-18x24');
      else if (size.includes('16') && size.includes('20')) hint = this.getAttribute('data-hint-16x20');
      else if (size.includes('12') && size.includes('16')) hint = this.getAttribute('data-hint-12x16');
      else if (size.includes('11') && size.includes('14')) hint = this.getAttribute('data-hint-11x14');

      const labelIn = sizeInput instanceof HTMLInputElement
        ? (sizeInput.getAttribute('data-ke-label-in') || size)
        : size;
      const labelCm = sizeInput instanceof HTMLInputElement
        ? (sizeInput.getAttribute('data-ke-label-cm') || labelIn)
        : labelIn;

      delete this.dataset.digital;
      if (scaleLine) scaleLine.hidden = false;
      if (sizeElement) {
        sizeElement.setAttribute('data-label-in', labelIn);
        sizeElement.setAttribute('data-label-cm', labelCm);
        sizeElement.textContent = this.getCurrentUnit() === 'cm' ? labelCm : labelIn;
      }
      if (hintElement) {
        hintElement.hidden = false;
        if (hint) hintElement.textContent = hint;
      }
      if (separator) separator.hidden = false;
    }
  }

  if (!customElements.get('ke-size-guide')) {
    customElements.define('ke-size-guide', KeSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
